/* eslint-disable sonarjs/cognitive-complexity */
import React, { useEffect } from "react";
import { useAppSelector } from "hooks";
import { accessoriesSorter } from "utils/commonFunctions";
import CommonLoader from "components/CommonLoader";

function VehicleDetails() {
  const nsoSelector = useAppSelector((state) => state.nsoFlow.nsoFlow.data[1].data);
  const nsoSelectorLoading = useAppSelector((state) => state.nsoFlow.nsoFlow.loading);
  const [accessories, setAccessories] = React.useState<any>({});
  // console.log("VehicleDetails -> accessories", nsoSelector?.response_json?.preProductionSerialNumber);
  const vehicleIdentifierData: Array<any> = [
    {
      id: 1,
      name: "Model Year",
      value: nsoSelector?.response_json?.modelYear ?? "",
    },
    {
      id: 2,
      name: "URN",
      value: nsoSelector?.response_json?.urn ?? "",
    },
    {
      id: 3,
      name: "Model | Serial",
      value: `${
        nsoSelector?.response_json?.modelYear ?? ""
      } | ${nsoSelector?.response_json?.preProductionSerialNumber ?? ""}`,
    },
    {
      id: 4,
      name: "VIN",
      value: nsoSelector?.response_json?.preProductionVIN ?? "",
    },
    {
      id: 5,
      name: "WMI",
      value: nsoSelector?.response_json?.wmi ?? "",
    },
    {
      id: 6,
      name: "Dealer Reserved Indicator",
      value: nsoSelector?.response_json?.dealerReservedIndicator ? "Yes" : "No",
    },
    {
      id: 7,
      name: "Region Code | Region Name",
      value: `${nsoSelector?.response_json?.currentDealer?.currentRegionCode ?? ""}  | ${
        nsoSelector?.response_json?.currentDealer?.currentRegionName ?? ""
      }`,
    },
  ];
  const colorData: Array<any> = [
    {
      id: 1,
      name: "Exterior",
      value: nsoSelector?.response_json?.exteriorColor ?? "",
    },
    {
      id: 2,
      name: "Interior",
      value: nsoSelector?.response_json?.interiorColor ?? "",
    },
  ];
  const orderInformationData: Array<any> = [
    {
      id: 1,
      name: "Build Week Number",
      value: nsoSelector?.response_json?.vehicleDates?.currentBuildWeekNumber ?? "",
    },
    {
      id: 2,
      name: "Production Month",
      value: nsoSelector?.response_json?.vehicleDates?.orderProductionMonth ?? "",
    },
    {
      id: 3,
      name: "Production Year",
      value: nsoSelector?.response_json?.vehicleDates?.orderProductionYear ?? "",
    },
    {
      id: 4,
      name: "Estimated Build Date",
      value: nsoSelector?.response_json?.vehicleDates?.originalEstimatedBuildDate ?? "",
    },
    {
      id: 5,
      name: "Order Month",
      value: nsoSelector?.response_json?.vehicleDates?.orderProductionMonth ?? "",
    },
  ];
  const vehicleEventData: Array<any> = [
    {
      id: 1,
      name: "Lifecycle Status",
      value: nsoSelector?.response_json?.vehicleEvent?.lifeCycleSubstatusDescription ?? "",
    },
  ];

  useEffect(() => {
    const sortConfigurations = async () => {
      if (nsoSelector?.response_json?.accessoryDetail) {
        try {
          const sortedData = await accessoriesSorter(nsoSelector?.response_json?.accessoryDetail);
          // console.log("sortedData", sortedData);
          setAccessories(sortedData);
        } catch (error) {
          console.error("Error sorting original config: ", error);
        }
      }
    };
    sortConfigurations();
  }, [nsoSelector?.response_json?.accessoryDetail]);

  const renderData: Array<any> = [
    {
      id: 1,
      title: "Vehicle Identifier",
      data: vehicleIdentifierData,
    },
    {
      id: 2,
      title: "Color",
      data: colorData,
    },
    {
      id: 3,
      title: "Order Information",
      data: orderInformationData,
    },
    {
      id: 4,
      title: "Vehicle Event",
      data: vehicleEventData,
    },
  ];
  useEffect(() => {
    // console.log("VehicleDetails -> nsoSelector",);
  }, [nsoSelector]);
  if (nsoSelectorLoading) {
    return <CommonLoader active={nsoSelectorLoading} />;
  }
  return (
    <>
      <div className="border border-gray-300 rounded-lg shadow-lg gap-4">
        {renderData?.map((item) => {
          return (
            <div className="w-full bg-gray-100 rounded-lg py-2 m-2" key={item.id}>
              <div className="flex w-full justify-start items-center content-center">
                <span className="font-bold mx-4 text-xl">{item.title}</span>
              </div>
              <div className="border border-gray-300 rounded-lg my-2 mx-0"></div>

              <div className="grid grid-cols-3 m-1 gap-2">
                {item?.data?.map((items: any) => (
                  <div className="" key={items.id}>
                    <div className="bg-yellow grid grid-cols-2 m-2 gap-4">
                      <div className="text-sm">{items.name}</div>
                      {items.name ? <div className="text-base">{items.value}</div> : <></>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
        <div className="w-full bg-gray-100 rounded-lg py-2 m-2">
          <div className="flex w-full justify-start items-center content-center">
            <span className="font-bold mx-4 text-xl">Accessories</span>
          </div>
          <div className="border border-gray-300 rounded-lg my-2 mx-0"></div>
          <div className="grid grid-cols-1 m-1 gap-2">
            {Object.entries(accessories).map(([key, value]) => (
              <div className="" key={key}>
                <div className="bg-yellow grid col-span-3 grid-cols-12 m-2 gap-4">
                  <div className="text-sm">
                    {key === "factoryAccessory" ? "Factory" : key === "ppoAccessory" ? "PPO" : "Confirmed ILA"}
                  </div>
                  <div className="text-sm capitalize col-start-3 col-end-12">
                    {(value as string[])?.map((item: string) => item).join(", ")}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default VehicleDetails;
